(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icons-with-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let queued = false;
    const updateRatings = () => {
      queued = false;
      const source = document.querySelector('.jdgm-all-reviews-text__text[data-score][data-number-of-reviews]');
      if (!source) return;
      const score = Number(source.getAttribute('data-score'));
      const count = Number(source.getAttribute('data-number-of-reviews'));
      if (!Number.isFinite(score) || score <= 0 || score > 5 || !Number.isInteger(count) || count <= 0) return;
      document.querySelectorAll('[data-pd-live-reviews]').forEach(target => {
        const format = target.getAttribute('data-rating-format');
        if (!format) return;
        const text = format.replaceAll('{rating}', score.toFixed(1)).replaceAll('{count}', count.toLocaleString(document.documentElement.lang || 'en'));
        if (target.textContent !== text) target.textContent = text;
      });
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(updateRatings);
    };
    const start = () => {
      updateRatings();
      const observer = new MutationObserver(schedule);
      observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['data-score','data-number-of-reviews']});
      window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
